const currentModeId = {
  bjlink: {
    // 线上
    production: 7,
    // 测试
    test: 125,
  },

  // 佛山
  foshan: {
    // 线上
    production: 10,
    // 测试
    test: 396,
  },

  // 合肥
  hefei: {
    // 线上
    production: 13,
    // 测试
    test: 125,
  },
};
const uniStoreInfo = {
  jinhua: {
    id: 70,
    name: '金华门店',
  },
  haerbin: {
    id: 25,
    name: '哈尔滨门店',
  },
  qiqihaer: {
    id: 80,
    name: '齐齐哈尔邻客大药房有限公司',
  },
  shenzhen: {
    id: 62,
    name: '深圳门店',
  },
  lanzhou: {
    id: 29,
    name: '兰州邻客门店',
  },
  nanchang: {
    id: 38,
    name: '南昌邻客智慧药房',
  },
  bjlink: {
    id: currentModeId.bjlink[process.env.VUE_APP_CURRENTMODE],
    name: '北京邻客大药房有限公司',
  },
  bjXizhong: {
    id: 7,
    name: '北京西肿门店',
  },
  shanghai: {
    id: 57,
    name: '上海门店',
  },
  foshan: {
    id: currentModeId.foshan[process.env.VUE_APP_CURRENTMODE],
    name: '佛山邻客大药房有限公司',
  },
  hefei: {
    id: currentModeId.hefei[process.env.VUE_APP_CURRENTMODE],
    name: '合肥门店',
  },
  rd: {
    id: 3,
    name: 'rd门店',
  },
  isNeedPassword(id) {
    const list = [
      uniStoreInfo.haerbin.id,
      uniStoreInfo.shenzhen.id,
      uniStoreInfo.qiqihaer.id,
    ]; // 医保门店读卡时是否需要手动输入密码 25哈尔滨门店
    return list.includes(id);
  },
  changePasIsShowInput(id) {
    const list = [
      uniStoreInfo.haerbin.id,
      uniStoreInfo.qiqihaer.id,
    ]; // 目前只有哈尔滨门店改密码需要在页面上输入，其他门店的都在门店设备上输入密码，不需要展示input密码框。
    return list.includes(id);
  },
  isUseInsSettleBillPrintModel(id) {
    const list = [
      uniStoreInfo.haerbin.id,
      uniStoreInfo.nanchang.id,
      uniStoreInfo.qiqihaer.id,
    ];
    return list.includes(id);
  },
  isGuangdongSocialSecurity(id) {
    const list = [
      uniStoreInfo.foshan.id,
      uniStoreInfo.shenzhen.id,
    ];
    return list.includes(id);
  },
  isNeedUseFinger(id) {
    const list = [uniStoreInfo.jinhua.id];
    return list.includes(id);
  },
  isNeedPOSCollection(id) {
    const list = [
      uniStoreInfo.rd.id,
      uniStoreInfo.bjXizhong.id,
      uniStoreInfo.shanghai.id,
    ]; // pos收款支持某些门店
    return list.includes(id);
  },
  isNeedSalePromotionInfo(id) {
    const list = [uniStoreInfo.bjlink.id]; // 其他折扣
    return list.includes(id);
  },
};
export default uniStoreInfo;
